(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
function initializeWalkHeroVideos() {
  document.querySelectorAll('[data-walk-hero-video]').forEach((video) => {
    if (video.dataset.walkInitialized) return;
    video.dataset.walkInitialized = 'true';
    const button = video.closest('.home-section').querySelector('[data-walk-hero-toggle]');
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const clips = [
      'https://cdn.shopify.com/videos/c/o/v/d6093632750d4c71811e0f644fb60b16.mp4',
      'https://cdn.shopify.com/videos/c/o/v/214b3a797c4c4438a7a8da3835637eb2.mp4'
    ];
    let index = 0;
    let requestedPlayback = !motion.matches;
    const update = () => { button.textContent = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel; };
    const play = () => { video.muted = true; video.play().catch(update); };
    button.addEventListener('click', () => {
      requestedPlayback = video.paused;
      if (requestedPlayback) play(); else video.pause();
    });
    video.addEventListener('play', update);
    video.addEventListener('pause', update);
    video.addEventListener('ended', () => {
      index = (index + 1) % clips.length;
      video.src = clips[index];
      video.load();
      if (requestedPlayback) play();
    });
    motion.addEventListener('change', () => {
      if (motion.matches) { requestedPlayback = false; video.pause(); }
    });
    update();
    if (requestedPlayback) play();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeWalkHeroVideos); else initializeWalkHeroVideos();
document.addEventListener('shopify:section:load', initializeWalkHeroVideos);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-section"] && !Shopify.designMode) return;
  try {
    
function initializeWalkVideos() {
  document.querySelectorAll('[data-walk-background-video]').forEach((video) => {
    if (video.dataset.walkInitialized) return;
    video.dataset.walkInitialized = 'true';
    const button = video.closest('.video-sec').querySelector('[data-walk-video-toggle]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const update = () => { button.textContent = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel; };
    const play = () => { video.muted = true; video.play().catch(update); };
    button.addEventListener('click', () => { if (video.paused) play(); else video.pause(); });
    video.addEventListener('play', update);
    video.addEventListener('pause', update);
    reducedMotion.addEventListener('change', () => { if (reducedMotion.matches) video.pause(); });
    update();
    if (!reducedMotion.matches) play();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeWalkVideos); else initializeWalkVideos();
document.addEventListener('shopify:section:load', initializeWalkVideos);

  } catch(e) { console.error(e); }
})();
})();
